<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <span class="fs-5 fw-bold mb-0">My Account</span>
    </li>
  </ol>
</nav>

<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-header fw-bold bg-tertiary p-3 border-0">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-person-bounding-box me-2"></i>Personal Informations</h2>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-4">
          <label for="password" class="form-label">Password</label>
          <div class="input-group">
            @if (form.get('password')?.value) {
              <copy-to-clipboard [content]="$safeNavigationMigration(form.get('password')?.value)" [displayContent]="false">
                <span class="input-group-text"><i class="bi bi-lock-fill"></i></span>
              </copy-to-clipboard>
            }

            @if (!form.get('password')?.value) {
              <span class="input-group-text"><i class="bi bi-lock-fill"></i></span>
            }

            <input type="text" id="password" class="form-control" formControlName="password">

            <span (click)="randomPassword()" class="input-group-text" title="Generate secured password" role="button">
              <i class="bi bi-repeat"></i>
            </span>
          </div>
        </div>

        <div class="col-auto pt-4">
          <button class="btn btn-primary fw-bold" [disabled]="form.invalid" type="submit">Update</button>
        </div>
      </div>
    </div>
  </div>

</form>
